var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPuzzleCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.5C18.78 12.5 19 12.72 19 13V15H25V21H27C27.28 21 27.5 21.22 27.5 21.5C27.5 21.78 27.28 22 27 22H25V28H22.88C22.2 26.25 20.49 25 18.5 25C16.51 25 14.8 26.25 14.12 28H12V25.88C13.75 25.2 15 23.49 15 21.5C15 19.51 13.76 17.8 12.01 17.12L12 15H18V13C18 12.72 18.22 12.5 18.5 12.5ZM18.5 10.5C17.12 10.5 16 11.62 16 13H12C10.9 13 10.01 13.9 10.01 15V18.8H10.3C11.79 18.8 13 20.01 13 21.5C13 22.99 11.79 24.2 10.3 24.2H10V28C10 29.1 10.9 30 12 30H15.8V29.7C15.8 28.21 17.01 27 18.5 27C19.99 27 21.2 28.21 21.2 29.7V30H25C26.1 30 27 29.1 27 28V24C28.38 24 29.5 22.88 29.5 21.5C29.5 20.12 28.38 19 27 19V15C27 13.9 26.1 13 25 13H21C21 11.62 19.88 10.5 18.5 10.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPuzzleCircle);
export default __webpack_public_path__ + "static/media/ic_puzzle_circle.9e743748e902ce8be800b1662eed19a0.svg";
export { ForwardRef as ReactComponent };